import {FC, useEffect, useState} from 'react'
import {Field, ErrorMessage, useField} from 'formik'
import {useIntl} from 'react-intl'
import {AnimaDireita2} from '../../../../../../../../_metronic/assets/animation/styles'

import {Calendar} from 'primereact/calendar'
import {insertDataTime} from '../../../../../../../../util/insertDataTime'
import moment from 'moment'
import {Chips} from 'primereact/chips'
import {handleInputChange} from 'react-select/dist/declarations/src/utils'
import CreatableSelect from 'react-select/creatable'
import {colourStyles} from '../../../../../providence/pages/addProvidence/styles/styles'

const Step2: FC = () => {
  // const animatedComponents = makeAnimated()
  const intl = useIntl()
  const [fieldIssueDate, metaIssueDate, helperIssueDate] = useField('issue_date')
  const [, , helperExpirationDate] = useField('expiration_date')
  const [, , helperLimitRenovation] = useField('limit_renovation')
  const [, , helperRenovationRequest] = useField('renovation_request_date')
  const [, , helperFinalizationDate] = useField('finalization_date')
  const [fieldStatus, metaStatus, helperStatus] = useField('status')
  const [, ,] = useField('renovation_protocol')
  const [fieldRenewable, ,] = useField('renewable')
  // console.log('teste', fieldRenewable)

  const [fieldRenovationAlertDays, metaRenovationAlertDays, helperRenovationAlertDays] =
    useField('renovation_alert_days')

  const [selectedRenovationAlertDays, setSelectedRenovationAlertDays] = useState<number[]>(
    fieldRenovationAlertDays.value
  )

  const [issue_date, setIssue_date] = useState<Date | undefined>()
  const [expiration_date, setExpiration_dateD] = useState<Date | undefined>()
  const [limit_renovation, setLimit_renovation] = useState<Date | undefined>()
  const [renovation_request, setRenovation_request] = useState<Date | undefined>()
  const [finalization_date, setFinalization_date] = useState<Date | undefined>()

  const setConvertDate = (
    e: any,
    typeDate: 'issue' | 'expiration' | 'limited' | 'renovation' | 'finalization'
  ) => {
    let DateFormate: any
    switch (typeDate) {
      case 'issue': {
        DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
        setIssue_date(e)
        helperIssueDate.setValue(DateFormate)
        break
      }
      case 'expiration': {
        DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
        setExpiration_dateD(e)
        helperExpirationDate.setValue(DateFormate)
        break
      }
      case 'limited': {
        DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
        setLimit_renovation(e)
        helperLimitRenovation.setValue(DateFormate)
        break
      }
      case 'renovation': {
        DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
        setRenovation_request(e)
        helperRenovationRequest.setValue(DateFormate)
        break
      }
      case 'finalization': {
        DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
        setFinalization_date(e)
        helperFinalizationDate.setValue(DateFormate)
        break
      }
    }
  }
  insertDataTime()

  const handleInputChangeRenovationAlertDays = (event: any) => {
    console.log('event', event)
    var inputValue = []
    if (event) {
      for (var i = 0; i < event.length; i++) {
        inputValue.push(parseInt(event[i].value))
      }

      setSelectedRenovationAlertDays(event)
      helperRenovationAlertDays.setValue(inputValue)
    }
    return {inputValue}
  }

  return (
    <div className='w-100'>
      <AnimaDireita2>
        <div className='mb-10'>
          <h2 className='fw-bolder text-dark'>
            {intl.formatMessage({id: 'LICENSES.TITLE_STEAP2'})}
          </h2>
          <div className='text-gray-400 fw-bold fs-6'>
            {intl.formatMessage({id: 'LICENSES.SUBTITLE_STEAP2'})}
          </div>
        </div>

        <div className='card-body  p-0 '>
          {/* inicio da segunda linha */}
          <div className='row'>
            <div className='col-lg-6'>
              <label className='form-label fw-bold required'>
                {intl.formatMessage({id: 'LICENSES.ISSUE_DATE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                {/* <input type='date' className='form-control form-control-solid  ps-6' {...field} /> */}
                <Calendar
                  value={issue_date}
                  onChange={(e: any) => setConvertDate(e.value, 'issue')}
                  selectionMode='single'
                  inputClassName='form-control form-control-solid ps-6 fw-bold border-white'
                  style={{
                    width: '100%',
                  }}
                  dateFormat='dd/mm/yy'
                  placeholder='dd/mm/aaaa'
                  showButtonBar
                  // disabled={isDisabledEnable}
                />
                <ErrorMessage name='issue_date' />
              </div>
            </div>

            <div className='col-lg-6'>
              <label className='form-label fw-bold required'>
                {intl.formatMessage({id: 'LICENSES.EXPIRATION_DATE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <Calendar
                  value={limit_renovation}
                  onChange={(e: any) => setConvertDate(e.value, 'limited')}
                  selectionMode='single'
                  inputClassName='form-control form-control-sm form-control-solid  ps-6 fw-bold border-white'
                  style={{
                    width: '100%',
                  }}
                  dateFormat='dd/mm/yy'
                  placeholder='dd/mm/aaaa'
                  showButtonBar
                  // disabled={isDisabledEnable}
                />
              </div>
            </div>
          </div>

          {/* fim da segunda linha */}

          {/* inicio da segunda linha */}
          {fieldRenewable.value === true && (
            <div className='row mt-3'>
              <div className='col-lg-6'>
                <label className='form-label fw-bold required'>
                  {intl.formatMessage({id: 'LICENSES.LIMIT_DATE_RENEW'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <Calendar
                    value={expiration_date}
                    onChange={(e: any) => setConvertDate(e.value, 'expiration')}
                    selectionMode='single'
                    inputClassName='form-control form-control-sm form-control-solid  ps-6 fw-bold border-white'
                    style={{
                      width: '100%',
                    }}
                    showButtonBar
                    // disabled={isDisabledEnable}
                    dateFormat='dd/mm/yy'
                    placeholder='dd/mm/aa'
                  />
                </div>
              </div>

              <div className='col-lg-6'>
                <label className='form-label fw-bold'>
                  {intl.formatMessage({id: 'LICENSE_RENEWAL_REQUEST_DATE'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <Calendar
                    value={renovation_request}
                    onChange={(e: any) => setConvertDate(e.value, 'expiration')}
                    selectionMode='single'
                    inputClassName='form-control form-control-sm form-control-solid  ps-6 fw-bold border-white'
                    style={{
                      width: '100%',
                    }}
                    dateFormat='dd/mm/yy'
                    placeholder='dd/mm/aaaa'
                    showButtonBar
                    // disabled={isDisabledEnable}
                  />
                </div>
              </div>
            </div>
          )}
          {/* fim da segunda linha */}

          {/* inicio da segunda linha */}
          <div className='row mt-3'>
            <div className='col-lg-6'>
              <label className='form-label fw-bold required'>
                {intl.formatMessage({id: 'COMMON.STATUS'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <select
                  className='form-select form-select-solid ps-6'
                  data-kt-select2='true'
                  {...fieldStatus}
                  //onChange={(e) => setstatus(e.target.value)}
                >
                  <option value='valid'>{intl.formatMessage({id: 'LICENSES.STATUS_1'})}</option>
                  <option value='waiting_license'>
                    {intl.formatMessage({id: 'LICENSES.STATUS_2'})}
                  </option>
                  <option value='in_renovation'>
                    {intl.formatMessage({id: 'LICENSES.STATUS_3'})}
                  </option>
                  <option value='renewed_replaced'>
                    {intl.formatMessage({id: 'LICENSES.STATUS_4'})}
                  </option>
                  <option value='finished'>{intl.formatMessage({id: 'LICENSES.STATUS_5'})}</option>
                  <option value='expired'>{intl.formatMessage({id: 'LICENSES.STATUS_6'})}</option>
                  <option value='changed_ownership'>
                    {intl.formatMessage({id: 'LICENSES.STATUS_7'})}
                  </option>
                  <option value='waiting_documentation'>
                    {intl.formatMessage({id: 'LICENSES.STATUS_8'})}
                  </option>
                </select>
                {metaStatus.touched && metaStatus.error && (
                  <div className='text-danger text-center fs-9 fw-bold '>{metaStatus.error}</div>
                )}
              </div>
            </div>

            <div className='col-lg-6'>
              <label className='form-label  fw-bold'>
                {intl.formatMessage({id: 'LICENSE_DATE_COMPLETION'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <Calendar
                  value={finalization_date}
                  onChange={(e: any) => setConvertDate(e.value, 'finalization')}
                  selectionMode='single'
                  inputClassName='form-control form-control-sm form-control-solid  ps-6 fw-bold border-white'
                  style={{
                    width: '100%',
                  }}
                  dateFormat='dd/mm/yy'
                  placeholder='dd/mm/aaaa'
                  showButtonBar
                  disabled
                />
              </div>
            </div>
          </div>

          {/* fim da segunda linha */}

          {/* inicio da segunda linha */}
          {fieldRenewable.value === true && (
            <div className='row mt-3'>
              {selectedRenovationAlertDays && (
                <div className='col-lg-6'>
                  <label className='form-label  fw-bold required'>
                    {intl.formatMessage({id: 'LICENSE_RENEWAL_NOTICE'})}
                  </label>
                  {/* <Chips
                    className='form-control form-control-sm form-control-solid p-0 border border-white'
                    value={selectedRenovationAlertDays}
                    onChange={(e) => {
                      helperRenovationAlertDays.setValue(e.value)
                      setSelectedRenovationAlertDays(e.value)
                    }}
                    style={{
                      fontFamily: 'Poppins',
                      fontSize: '1.15rem',
                      fontWeight: 'medium',
                      width: '100%',
                    }}
                  /> */}
                  <CreatableSelect
                    className='form-control form-control-lg form-control-solid p-1 pl-1'
                    styles={colourStyles}
                    isMulti
                    placeholder='Quant. de dias'
                    {...fieldRenovationAlertDays}
                    value={selectedRenovationAlertDays}
                    onChange={handleInputChangeRenovationAlertDays}
                  />
                  {metaRenovationAlertDays.error ? (
                    <div className='text-danger text-center fs-9 fw-bold '>
                      {metaRenovationAlertDays.error}
                    </div>
                  ) : null}
                </div>
              )}
              <div className='col-lg-6'>
                <label className='form-label fw-bold'>
                  {intl.formatMessage({id: 'LICENSE_RENEWAL_PROTOCOL'})}
                </label>

                <div className='d-flex align-items-center position-relative my-1'>
                  <Field
                    name='renovation_protocol'
                    className='form-control form-control-lg form-control-solid'
                    // placeholder={intl.formatMessage({id: 'LICENSES.NUMBER_DOC'})}
                    placeholder=''
                  />
                  <div className='text-danger mt-2'>
                    <ErrorMessage name='renovation_protocol' />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* fim da segunda linha */}
        </div>
      </AnimaDireita2>
    </div>
  )
}

export {Step2}
